import { Table, type TableProps } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { Empty } from './Empty';

export interface Column<T> {
  id: string;
  header: string;
  accessor: (row: T) => React.ReactNode;
  className?: string;
  width?: number | string;
}

interface DataTableProps<T> {
  columns: Column<T>[];
  data: T[];
  loading?: boolean;
  emptyMessage?: string;
  className?: string;
  rowKey?: string | ((record: T) => string);
  rowSelection?: TableProps<T>['rowSelection'];
}

export function DataTable<T extends { id: string }>({
  columns,
  data,
  loading = false,
  emptyMessage = '暂无数据',
  className,
  rowKey = 'id',
  rowSelection,
}: DataTableProps<T>) {
  // 转换 columns 格式为 antd Table 需要的格式
  const antColumns: ColumnsType<T> = columns.map((col) => ({
    key: col.id,
    title: col.header,
    dataIndex: col.id,
    className: col.className,
    width: col.width,
    render: (_: unknown, record: T) => col.accessor(record),
  }));

  return (
    <Table<T>
      columns={antColumns}
      dataSource={data}
      loading={loading}
      rowKey={rowKey}
      rowSelection={rowSelection}
      pagination={false}
      className={className}
      locale={{
        emptyText: <Empty description={emptyMessage} />,
      }}
      size="middle"
      scroll={{ x: 'max-content' }}
    />
  );
}
